import { SUPPORTED_LANGUAGES } from "@/shared/types/language.types"

export { SUPPORTED_LANGUAGES }

export const I18N_NAMESPACES = [
  "translations",
  "template-translations",
  "moderation-commands",
  "service-messages",
  "invitation-settings",
  "faq",
  "common",
  "ai-learning",
  "ai-settings",
  "clones",
  "level-system",
  "user-cabinet",
  "event-log",
  "chat-grid",
  "grid-subscription",
  "celestia-pro",
  "telegram"
] as const

export const DEFAULT_NAMESPACE: (typeof I18N_NAMESPACES)[number] = "translations"
